import {
    AUTHENTICATING_USER,
    AUTHENTICATING_USER_FAILURE,
    AUTHENTICATING_USER_SUCCESS,
    USER_FAVORITES_LOADING,
    GET_FAVORITES_SUCCESS,
    GET_FAVORITES_FAILURE,
    ADDING_FAVORITE_DASHBOARD,
    POST_FAVORITE_DASHBOARD_SUCCESS,
    POST_FAVORITE_DASHBOARD_FAILURE,
    REMOVING_FAVORITE_DASHBOARD,
    REMOVE_FAVORITE_DASHBOARD_SUCCESS,
    REMOVE_FAVORITE_DASHBOARD_FAILURE,
} from 'redux/reduxConstants';
import { decode } from 'utilities/jwt';

const initialState = {
    accessToken: '',
    accessTokenExpiresOn: '',
    authenticated: false,
    userName: '',
    email: '',
    admin: false,
    roles: [],
    authenticatingUser: false,
    favoriteDashboardsLoading: false,
    favoriteUserDashboards: [],
    addingFavorite: false,
    removingFavorite: false,
    error: '',
};

const user = (state = initialState, action) => {
    switch (action.type) {
        case AUTHENTICATING_USER:
            let authenticatingUser = { ...state };
            authenticatingUser.authenticatingUser = true;

            return authenticatingUser;
        case AUTHENTICATING_USER_SUCCESS:
            let authenticatingUserSuccess = { ...state };
            authenticatingUserSuccess.authenticatingUser = false;
            const jwt = decode(action.accessToken);
            let admin = false;

            if (jwt.roles) {
                admin = jwt.roles[0].includes('Admin') ? true : false;
            }

            authenticatingUserSuccess.accessToken = action.accessToken;
            authenticatingUserSuccess.accessTokenExpiresOn = action.expiresOn;
            authenticatingUserSuccess.authenticated = true;
            authenticatingUserSuccess.roles = jwt.roles;
            authenticatingUserSuccess.admin = admin;
            authenticatingUserSuccess.userName = action.userName;
            authenticatingUserSuccess.email = action.email;

            return authenticatingUserSuccess;
        case AUTHENTICATING_USER_FAILURE:
            let authenticatingUserFailure = { ...state };
            authenticatingUserFailure.authenticatingUser = false;
            authenticatingUserFailure.error = action.error;

            return authenticatingUserFailure;

        case USER_FAVORITES_LOADING:
            let dashboardFavoritesLoadingState = { ...state };
            dashboardFavoritesLoadingState.favoriteDashboardsLoading = true;
            return dashboardFavoritesLoadingState;

        case GET_FAVORITES_SUCCESS:
            let dashboardFavoritesSuccess = { ...state };
            dashboardFavoritesSuccess.favoriteUserDashboards = action.favoriteDashboards;
            dashboardFavoritesSuccess.favoriteDashboardsLoading = false;
            return dashboardFavoritesSuccess;

        case GET_FAVORITES_FAILURE:
            let dashboardFavoritesFailure = { ...state };
            dashboardFavoritesFailure.favoriteDashboardsLoading = false;
            dashboardFavoritesFailure.error = action.error;
            return dashboardFavoritesFailure;

        case ADDING_FAVORITE_DASHBOARD:
            let addingFavoriteState = { ...state };
            addingFavoriteState.addingFavorite = true;
            return addingFavoriteState;

        case POST_FAVORITE_DASHBOARD_SUCCESS:
            let addingDashboardFavoriteSuccess = { ...state };
            addingDashboardFavoriteSuccess.favoriteUserDashboards.push(action.dashboard);
            addingDashboardFavoriteSuccess.addingFavorite = false;
            return addingDashboardFavoriteSuccess;

        case POST_FAVORITE_DASHBOARD_FAILURE:
            let addingDashboardFavoriteFailure = { ...state };
            addingDashboardFavoriteFailure.addingFavorite = false;
            addingDashboardFavoriteFailure.error = action.error;
            return addingDashboardFavoriteFailure;

        case REMOVING_FAVORITE_DASHBOARD:
            let removingFavoriteState = { ...state };
            removingFavoriteState.removingFavorite = true;
            return removingFavoriteState;

        case REMOVE_FAVORITE_DASHBOARD_SUCCESS:
            let removeDashboardFavoriteSuccess = { ...state };
            for (var i = removeDashboardFavoriteSuccess.favoriteUserDashboards.length - 1; i >= 0; --i) {
                if (removeDashboardFavoriteSuccess.favoriteUserDashboards[i].dashboardId === action.dashboardId) {
                    removeDashboardFavoriteSuccess.favoriteUserDashboards.splice(i, 1);
                    break;
                }
            }
            removeDashboardFavoriteSuccess.removingFavorite = false;
            return removeDashboardFavoriteSuccess;

        case REMOVE_FAVORITE_DASHBOARD_FAILURE:
            let removeDashboardFavoriteFailure = { ...state };
            removeDashboardFavoriteFailure.removingFavorite = false;
            removeDashboardFavoriteFailure.error = action.error;
            return removeDashboardFavoriteFailure;

        default:
            return state;
    }
};

export default user;
